<template>
	<div class="addMain">
		<el-form :model="form" :rules="rules" ref="frmAdd" label-width="100px" class="demo-ruleForm">
			<el-form-item label="类型" prop="type"><el-input v-model="form.type"></el-input></el-form-item>
			<el-form-item label="标签" prop="label"><el-input v-model="form.label"></el-input></el-form-item>
			<el-form-item label="值" prop="value"><el-input v-model="form.value"></el-input></el-form-item>
			<el-form-item label="描述" prop="description"><el-input v-model="form.description"></el-input></el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				
			},
			options: [],
			value: '',
			rules: {
				type: [
					{
						required: true,
						message: '请输入类型',
						trigger: 'blur'
					}
				],
				label: [
					{
						required: true,
						message: '请输入标签',
						trigger: 'blur'
					}
				],
				value: [
					{
						required: true,
						message: '请输入值',
						trigger: 'blur'
					}
				],
				description: [
					{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}
				]
			}
		};
	},
	mounted() {
		
	},
	methods:{
		
		},
	
};
</script>

<style scoped>
	.addMain .el-row{
		display: flex;
		align-items: center;
	}
	.addMain .el-row{
		margin-bottom:20px;
	}
	.addMain .el-select{
		width:100%;
	}
	.addMain .el-option{
		width:100%;
	}
</style>
